import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Link from 'app/components/Link';
import { LocaleContext } from 'app/containers/LocaleProvider';
import LINKS from 'app/const/links';

import { AuthContext } from 'app/containers/AuthContainer';
import styles from './order-details-footer.scss';


const locales = {
    ru: {
        offerLine1: 'Нажимая «Оплатить», вы соглашаетесь с условиями',
        offerLine2: 'пользовательского соглашения,',
        offerNotUnderlinedPart: 'политиками',
        offerLine3: 'конфиденциальности,',
        offerLine4: 'обработки перс. данных',
        offerLine5: 'рассылки',
    },
    en: {
        offerLine1: 'Pressing "Pay", you agree with ',
        offerSpan1: 'user agreement, ',
        offerNotUnderlinedPart: 'Policies, ',
        offerLine2: 'Terms and Conditions',
    },
};


const { OFFER_PAGE } = LINKS;


export const OrderDetailsFooter = (props) => {
    const {
        paymentWidgetType = null,
    } = props;

    const { isAuthed } = useContext(AuthContext);

    const footerClasses = cn({
        [styles['order-footer']]: true,
    });

    const { locale } = useContext(LocaleContext);
    return (
        <div className={footerClasses}>
            {!isAuthed && (
                <>
                    {locales[locale].offerLine1}
                    {' '}
                    <br className={styles['force-break-s']} />
                    <Link href="/offer/" className={styles.specialLink}>
                        {locales[locale].offerLine2}
                    </Link>
                    {' '}
                    <br className={styles['force-break-m']} />
                    <br className={styles['force-break-l']} />
                    {locales[locale].offerNotUnderlinedPart}
                    <br className={styles['force-break-s']} />
                    {' '}
                    <Link href="/privacy_policy/" className={styles.specialLink}>
                        {locales[locale].offerLine3}
                    </Link>
                    {' '}
                    <Link href="/personal_data_policy/" className={styles.specialLink}>
                        {locales[locale].offerLine4}
                    </Link>
                    {' '}
                    <br className="mobile-only" />
                    и
                    {' '}
                    <Link href="/mailing_policy/" className={styles.specialLink}>
                        {locales[locale].offerLine5}
                    </Link>
                </>
            )}
            {paymentWidgetType === 'sber' && (
                <>
                    &nbsp;и&nbsp;
                    <Link href="/delivery/#payment-terms">
                        условиями оплаты
                    </Link>
                </>
            )}
        </div>
    );
};

OrderDetailsFooter.propTypes = {
    paymentWidgetType: PropTypes.string,
};
